<template>
  <v-layout>
    <v-flex>
      <v-row>
        <v-col cols="12" class="py-0">
          <v-container fluid pt-0>
            <v-row align="center">
              <h1 class="headline">Extras</h1>
              <v-spacer></v-spacer>
              <div>
                <list-visible-columns-and-filter
                  :visible-columns="visibleColumns"
                  :selectable-headers="selectableHeaders"
                  v-model="search"
                  @change="onVisibleColumnsChange"
                ></list-visible-columns-and-filter>
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" fab dark color="primary" @click="createItem">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Create New Extra</span>
              </v-tooltip>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

      <v-card>
        <v-data-table
          :headers="filteredHeaders"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
          fixed-header
          hide-default-footer
        >
          <template v-slot:item.isAccommodation="{ item }">
            <v-simple-checkbox
              v-model="item.node.isAccommodation"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.isActivity="{ item }">
            <v-simple-checkbox
              v-model="item.node.isActivity"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.isTransport="{ item }">
            <v-simple-checkbox
              v-model="item.node.isTransport"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.isTravel="{ item }">
            <v-simple-checkbox
              v-model="item.node.isTravel"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.isOther="{ item }">
            <v-simple-checkbox
              v-model="item.node.isOther"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.isPackage="{ item }">
            <v-simple-checkbox
              v-model="item.node.isPackage"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.isChildOnly="{ item }">
            <v-simple-checkbox
              v-model="item.node.isChildOnly"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.percentChild="{ item }">
            <v-simple-checkbox
              v-model="item.node.percentChild"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.isInfantOnly="{ item }">
            <v-simple-checkbox
              v-model="item.node.isInfantOnly"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.commission="{ item }">
            <v-simple-checkbox
              v-model="item.node.commission"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.markup="{ item }">
            <v-simple-checkbox
              v-model="item.node.markup"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.discount="{ item }">
            <v-simple-checkbox
              v-model="item.node.discount"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.isMandatory="{ item }">
            <v-simple-checkbox
              v-model="item.node.isMandatory"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.noReport="{ item }">
            <v-simple-checkbox
              v-model="item.node.noReport"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.noVoucher="{ item }">
            <v-simple-checkbox
              v-model="item.node.noVoucher"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.capacityChange="{ item }">
            <v-simple-checkbox
              v-model="item.node.capacityChange"
              :disabled="true"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.notInUse="{ item }">
            <v-simple-checkbox
              v-model="item.node.notInUse"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-card>
      <extra-type-edit-dialog
        v-model="editedExtra"
        @close="showEditDialog = false"
        :show="showEditDialog"
        @save="onSave"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_EXTRA_SERVICE_TYPES_SEARCH_QUERY,
  EXTRA_SERVICE_TYPE_DELETE_MUTATION,
  EXTRA_SERVICE_TYPE_UPDATE_MUTATION,
  EXTRA_SERVICE_TYPE_CREATE_MUTATION,
} from "../../../../constants/graphql";
import DefaultListActions from "../../shared/DefaultListActions";
import ExtraEditor from "./ExtraEditor";
import SimpleListMixin from "../../../../mixins/SimpleListMixin";
import ListVisibleColumnsAndFilter from "../../shared/ListVisibleColumnsAndFilter";
import ExtraTypeEditDialog from "./ExtraTypeEditDialog.vue";

export default {
  name: "ExtrasList",

  components: {
    DefaultListActions,
    ExtraEditor,
    ListVisibleColumnsAndFilter,
    ExtraTypeEditDialog,
  },
  mixins: [SimpleListMixin],
  data() {
    return {
      search: "",
      extraTypes: {},
      editedExtra: null,
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "name",
        "code",
        "taxCode",
        "capacityChange",
        "actions",
      ]),
      headers: [
        {
          text: "Name",
          value: "node.name",
          name: "name",
        },
        {
          text: "Code",
          value: "node.code",
          name: "code",
        },
        {
          text: "Tax Code",
          value: "node.taxCode",
          name: "taxCode",
        },
        {
          text: "Capacity Change",
          value: "capacityChange",
          name: "capacityChange",
          align: "center",
        },
        {
          text: "Rate Type",
          value: "node.rateTypeCode",
          name: "rateTypeCode",
        },
        {
          text: "Accommodation",
          value: "isAccommodation",
          name: "accommodation",
          align: "center",
        },
        {
          text: "Activity",
          value: "isActivity",
          name: "activity",
          align: "center",
        },
        {
          text: "Transport",
          value: "isTransport",
          name: "transport",
          align: "center",
        },
        {
          text: "Travel",
          value: "isTravel",
          name: "travel",
          align: "center",
        },
        {
          text: "Other",
          value: "isOther",
          name: "other",
          align: "center",
        },
        {
          text: "Package",
          value: "isPackage",
          name: "package",
          align: "center",
        },
        {
          text: "Child Only",
          value: "isChildOnly",
          name: "childOnly",
          align: "center",
        },
        {
          text: "% Child",
          value: "percentChild",
          name: "percentChild",
          align: "center",
        },
        {
          text: "Infant Only",
          value: "isInfantOnly",
          name: "infantOnly",
          align: "center",
        },
        {
          text: "Commission",
          value: "commission",
          name: "commission",
          align: "center",
        },
        {
          text: "Markup",
          value: "markup",
          name: "markup",
          align: "center",
        },
        {
          text: "Discount",
          value: "discount",
          name: "discount",
          align: "center",
        },
        {
          text: "Mandatory",
          value: "isMandatory",
          name: "isMandatory",
          align: "center",
        },
        {
          text: "No Report",
          value: "noReport",
          name: "noReport",
          align: "center",
        },
        {
          text: "No Voucher",
          value: "noVoucher",
          name: "noVoucher",
          align: "center",
        },
        {
          text: "Not In Use",
          value: "notInUse",
          name: "notInUse",
          align: "center",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
      showEditDialog: false,
    };
  },

  computed: {
    items() {
      return this.extraTypes ? this.extraTypes.edges : [];
    },
    filteredHeaders() {
      return this.headers.filter(
        (h) => this.visibleColumns.indexOf(h.name) > -1
      );
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    createItem() {
      this.editedExtra = null;
      this.showEditDialog = true;
    },
    editItem(item) {
      this.editedExtra = { ...item.node };
      this.showEditDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: EXTRA_SERVICE_TYPE_DELETE_MUTATION,
          variables: {
            extraServiceTypeId: item.node.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: "Extra service type removed.",
      });
      if (this.$apollo.queries.extraTypes != null) {
        this.$apollo.queries.extraTypes.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
    },
    onSaved(context) {
      if (this.$apollo.queries.extraTypes != null) {
        this.$apollo.queries.extraTypes.refetch();
      }
      this.showEditDialog = false;
      this.editedExtra = null;
      let msg =
        context == "edit"
          ? "Extra service type updated."
          : "Extra service type created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    },
    onSave(payload) {
      this.$apollo
        .mutate({
          mutation: payload.id
            ? EXTRA_SERVICE_TYPE_UPDATE_MUTATION
            : EXTRA_SERVICE_TYPE_CREATE_MUTATION,
          variables: {
            ...payload,
          },
        })
        .then((result) => {
          this.onSaved(payload.id ? "edit" : "create");
        })
        .catch(this.removeGqlObjectErrorHandler);
    },
    showColumn(fieldName) {
      return this.visibleColumns.find((name) => name === fieldName);
    },
  },

  apollo: {
    extraTypes: {
      query: ALL_EXTRA_SERVICE_TYPES_SEARCH_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/ExtraTypesList.vue